import React from 'react';
import "./appBusiness.scss";

//images
import imgappBusiness from "../../../assets/connectors/appbusiness.png";
import { useTranslation } from 'react-i18next';
const AppBusiness = () => {

    const {t} = useTranslation()

    return (
        <div className="container-appbusiness">
            <div className="img-appbusiness">
                <img src={imgappBusiness} alt="" />
            </div>
            <div className="texts-appbusiness">
                <h1>{t("connectors.business_apps.title")}</h1>
                <p>{t("connectors.business_apps.section_text_1")}</p>
                <p>{t("connectors.business_apps.section_text_2")}</p>
                <p>{t("connectors.business_apps.section_text_3")}</p>
                {/* <button id="btn-appbusiness">Saiba mais</button> */}
            </div>
        </div>
    )
}

export default AppBusiness